import { registerBlockType } from '@wordpress/blocks';
import { RichText, AlignmentToolbar, BlockControls, InspectorControls, InnerBlocks, BlockAlignmentToolbar, BlockVerticalAlignmentToolbar } from '@wordpress/block-editor';
import { PanelBody, SelectControl, ToggleControl, RangeControl } from '@wordpress/components';
import { Fragment } from '@wordpress/element';
import { withState } from '@wordpress/compose';

const heroInnerColumn = [
    ['core/heading'],
    ['core/paragraph'],
    ['core/buttons']
];

const heroTemplate = [
    ['core/cover', {}, [
        ['new-blocks/hero-column']
    ]]
];

registerBlockType('new-blocks/contact-form', {
    title: 'Contact Form',
    description: 'Pardot contact form',
    icon: 'clipboard',
    category: 'widgets',
    example: {},
    edit() {
        return <div><h2>Contact Form Placeholder</h2></div>;
    },
    save() {
        return <div><h2>Contact Form Placeholder</h2></div>;
    },
});

registerBlockType('new-blocks/hero-template', {
    title: 'Hero Template',
    icon: 'table-col-after',
    category: 'layout',
    example: {},
    edit: props => {
        // console.log(props);
        return(
            <div className={props.className}>
                <InnerBlocks
                template={ heroTemplate }
                templateLock="all"
                />
            </div>
        );
    },

    save: ({className}) => {
        return (
            <div className={className}>
                <InnerBlocks.Content />
            </div>
        );
    }
});

registerBlockType('new-blocks/hero-column', {
    title: "Hero Column",
    icon: 'list-view',
    category: 'layout',
    parent: ['new-blocks/hero-template'],
    example: {},
    attributes: {
        alignment: {
            type: 'string',
            default: 'left'
        },
        verticalAlignment: {
            type: 'string',
            default: 'center'
        },
        width: {
            type: 'number',
            default: 50
        },
        isParentBlock: {
            type: 'boolean',
            default: false
        },
        isFullWidth: {
            type: 'boolean',
            default: false
        }
        
    },
    edit: props => {
        const {
            attributes: {
                alignment,
                verticalAlignment,
                width
            },
            className,
        } = props;
        
        
        const updateWidth = ( newContent ) => {
            props.setAttributes( {width: newContent } );
        }
        const updateAlignment = ( newContent ) => {
            props.setAttributes( {alignment: newContent } );
        }
        const updateVerticalAlignment = ( newContent ) => {
            props.setAttributes( {verticalAlignment: newContent } );
        }

        return(
            <Fragment>
                {
                <InspectorControls>
                    <PanelBody title="Alignment">
                            <BlockAlignmentToolbar
                                value={ alignment }
                                onChange={ updateAlignment }
                            />
                            <BlockVerticalAlignmentToolbar
                            value={ verticalAlignment }
                            onChange={ updateVerticalAlignment }
                            />
                    </PanelBody>
                    <PanelBody title="Width">
                        <RangeControl
                        label="width"
                        value={width}
                        min={10}
                        max={100}
                        onChange={updateWidth}
                        />

                    </PanelBody>

                </InspectorControls>
    }          
                <div className={`${ props.className } is-aligned-${ alignment } is-vertically-aligned-${ verticalAlignment }`} style={{ flexBasis: width + '%' }}>
                    <InnerBlocks
                    template={ heroInnerColumn }
                    allowedBlocks={ ['core/heading', 'core/paragraph', 'core/buttons', 'core/html', 'acf/video-popup'] }
                    templateLock={ false } 
                    />
                </div>
            </Fragment>
        );
 
    },
    save: props => {
        return (
            <div className={ `${props.className} is-aligned-${ props.attributes.alignment } is-vertically-aligned-${props.attributes.verticalAlignment}` }
            style={{ flexBasis: props.attributes.width + '%' }}
            >
                <InnerBlocks.Content />
            </div>
        );
    },

});
